import * as St from './DocumentViewer.styles';

type DocumentViewerProps = {
  url: string;
};

const DocumentViewer = ({ url }: DocumentViewerProps): JSX.Element => (
  <St.Container src={url} title="Document Viewer" />
);

export default DocumentViewer;
